export const rest = {

	service() {

		const service = {
			path: "SunstonevNext/SunstonevNext.Account",
			framework: $.ServicesFramework(window.sunstonevNext.apps.account.data.moduleId)
		};

		service.baseUrl = service.framework.getServiceRoot(service.path);
		return service;
	},

	get(path, action, dataType, data) {
		return createRequest(this.service(), path, action, dataType, "GET", data);
	},

	post(path, action, dataType, data, contentType) {
		return createRequest(this.service(), path, action, dataType, "POST", data, contentType);
	}

}

var createRequest = function (service, path, action, dataType, method, data, contentType) {

	if (contentType === "multipart/form-data") {
		return jQuery.ajax({
			url: service.baseUrl + path + action,
			method: method,
			contentType: false,
			processData: false,
			beforeSend: service.framework.setModuleHeaders,
			dataType: dataType,
			data: data
		});
	}

	return jQuery.ajax({
		url: service.baseUrl + path + action,
		method: method,
		contentType: contentType || 'application/json; charset=UTF-8',
		beforeSend: service.framework.setModuleHeaders,
		dataType: dataType,
		data: data
	});
}
